var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMessageCircleOff = _a => {
  var _b, _c, _d;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51739 1.54511C2.2489 1.27663 1.8136 1.27663 1.54511 1.54511C1.27663 1.8136 1.27663 2.2489 1.54511 2.51739L6.16557 7.13784C5.27439 8.52333 4.77454 10.1588 4.77387 11.8704C4.77059 13.1292 5.04307 14.3736 5.57075 15.5154L3.86406 20.6355C3.67912 21.1903 4.20694 21.7181 4.76174 21.5332L9.8818 19.8265C11.0236 20.3541 12.2681 20.6266 13.5284 20.6233C15.2389 20.6227 16.8739 20.1229 18.2593 19.2316L21.4826 22.4549C21.7511 22.7234 22.1864 22.7234 22.4549 22.4549C22.7234 22.1864 22.7234 21.7511 22.4549 21.4826L2.51739 1.54511ZM17.2274 18.1997L7.19753 8.1698C6.5523 9.27237 6.19375 10.545 6.19324 11.8725C6.19028 13.0096 6.45595 14.1314 6.96863 15.1464C7.05395 15.3153 7.06827 15.5113 7.00844 15.6908L5.65943 19.7378L9.70646 18.3888C9.88597 18.329 10.0819 18.3433 10.2508 18.4286C11.2658 18.9413 12.3876 19.207 13.5263 19.204C14.8529 19.2035 16.125 18.845 17.2274 18.1997Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }), React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M21.3528 15.7836C21.2414 16.0064 21.1213 16.2231 20.993 16.4333L19.9544 15.3947C19.9992 15.313 20.0426 15.2302 20.0845 15.1464C20.5972 14.1314 20.8629 13.0096 20.8599 11.8725L20.861 11.4366C20.6556 7.71403 17.6832 4.74161 13.9997 4.53732L13.5247 4.53732C12.3876 4.53435 11.2658 4.80003 10.2481 5.31406C10.1652 5.35551 10.0833 5.39841 10.0024 5.44271L8.9638 4.40409C9.17317 4.27632 9.38898 4.15671 9.6109 4.0458C10.8254 3.43233 12.1677 3.11442 13.5266 3.11797L14.0388 3.11904C18.4837 3.36427 22.0329 6.91348 22.2792 11.3975V11.8698C22.2826 13.2301 21.9647 14.572 21.3528 15.7836Z",
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }));
};
export default SvgMessageCircleOff;